type StatusType =
  | "inbound"
  | "requested"
  | "dispatched"
  | "in_progress"
  | "completed"
  | "canceled"
  | "pending"
  | "approved";

interface StatusProps {
  status: StatusType;
}

export function StatusV2({ status }: StatusProps) {
  const getStyleFromStatus = (status: StatusType) => {
    switch (status) {
      case "pending":
        return "bg-yellow-50 text-yellow-700 ring-yellow-600/20";
      case "inbound":
      case "requested":
        return "text-gray-600 ring-gray-600/10 ring-0 border-dotted border-2 border-gray-400";
      case "dispatched":
      case "in_progress":
        return "bg-gray-100 text-gray-600 ring-gray-600/10";
      case "completed":
      case "approved":
        return "bg-green-50 text-green-700 ring-green-600/20";
      case "canceled":
        return "bg-red-50 text-red-700 ring-red-600/20";
    }
  };

  return (
    <span
      className={`inline-flex items-center rounded-full px-2 py-0.5 md:py-1 text-[8px] md:text-xs font-medium ring-1 ring-inset ${getStyleFromStatus(
        status,
      )}`}
    >
      {status
        .split("_")
        .map(
          (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
        )
        .join(" ")}
    </span>
  );
}
